import React, { useState } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row } from "react-bootstrap";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate } from "react-router-dom";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import AdminHeader from "../../common/Header";
import SubscriptionPlanForm from "./SubscriptionPlanForm";

const AddSubscription = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  // Correct Add API
  const addApi = Api({
    url: `api/subscription/plan/addPlan`,
  });

  // Handle add form submission
  const handleAddSubmit = async (formData) => {
    try {
      setIsLoading(true);

      const response = await addApi.postData(formData);

      if (response.data.statusType === "SUCCESS") {
        showToast("Subscription Plan Added Successfully", { type: "success" });

        setTimeout(() => {
          navigate("/subscription-plans");
        }, 2000);
      } else {
        showToast("Add Failed", { type: "error" });
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
      showToast("Error Occurred", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Subscription Plans", link: "/subscription-plans" },
    { label: "Add Subscription Plan", link: "", active: true },
  ];

  return (
    <>
      <Notification />
      <Container>
        <BreadCrumb items={breadcrumbItems} />

        <Row>
          <Col lg={3} md={4} sm={12}>
            <AdminHeader />
          </Col>

          <Col lg={9} md={8} sm={12}>
            <SingleDetailHeader
              header="Add Subscription Plan"
              description="Add new subscription plan details"
            />

            <SubscriptionPlanForm
              onSubmit={handleAddSubmit}
              loading={isLoading}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddSubscription;
